import { Component, EventEmitter, Output } from '@angular/core';

import { ZtTextInputConfig } from 'src/app/shared/components/atoms/zt-textinput/zt-textinput.model';
import {
    ZtFilterChangeEvent,
    ZtFilterEventType,
} from '../zt-filter/zt-filter.model';

@Component({
    selector: 'zt-string-filter',
    templateUrl: 'zt-string-filter.component.html',
})
export class ZtStringFilterComponent {
    @Output() filterChange = new EventEmitter<ZtFilterChangeEvent>();

    filteredText: string = '';
    config: ZtTextInputConfig = {
        type: 'text',
    };

    constructor() {}

    onChange(newValue: string) {
        this.filteredText = newValue;
        if (this.filteredText === '') {
            this.filterChange.emit({
                type: ZtFilterEventType.ALL_MATCH,
            } as ZtFilterChangeEvent);

            return;
        }

        this.filterChange.emit({
            type: ZtFilterEventType.MATCH,
            data: this.filteredText,
        } as ZtFilterChangeEvent);
    }
}
